import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { scrollToId } from "@/lib/site";

const pad = (n) => String(n).padStart(2, "0");
const SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;
const KEY = "tm_offer_deadline";

const getDeadline = () => {
  try {
    const saved = Number(localStorage.getItem(KEY));
    const now = Date.now();
    if (saved && saved > now) return saved;
    const next = now + SEVEN_DAYS;
    localStorage.setItem(KEY, String(next));
    return next;
  } catch {
    return Date.now() + SEVEN_DAYS;
  }
};

export default function CountdownBar() {
  const [left, setLeft] = useState({ d: "07", h: "00", m: "00", s: "00" });

  useEffect(() => {
    const deadline = getDeadline();
    const tick = () => {
      const diff = Math.max(0, deadline - Date.now());
      setLeft({
        d: pad(Math.floor(diff / 86_400_000)),
        h: pad(Math.floor((diff % 86_400_000) / 3_600_000)),
        m: pad(Math.floor((diff % 3_600_000) / 60_000)),
        s: pad(Math.floor((diff % 60_000) / 1000)),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="bg-[#12261A] text-[#FAF7F2] py-2.5 px-4 flex items-center justify-center gap-3 flex-wrap"
      data-testid="countdown-bar"
    >
      <span className="flex items-center gap-1.5 text-[11px] sm:text-xs font-bold tracking-[0.14em] uppercase text-[#D4A359]">
        <Flame className="w-4 h-4" />
        55% launch discount ends in
      </span>
      <span className="flex items-center gap-1 font-mono text-sm font-bold" data-testid="countdown-timer">
        <span className="bg-[#1C3A27] rounded px-1.5 py-0.5 tabular-nums">{left.d}</span>d :
        <span className="bg-[#1C3A27] rounded px-1.5 py-0.5 tabular-nums">{left.h}</span>h :
        <span className="bg-[#1C3A27] rounded px-1.5 py-0.5 tabular-nums">{left.m}</span>m :
        <span className="bg-[#1C3A27] rounded px-1.5 py-0.5 tabular-nums text-[#D4A359]">{left.s}</span>s
      </span>
      <button
        onClick={() => scrollToId("pricing")}
        className="text-[11px] sm:text-xs font-extrabold uppercase tracking-wide underline underline-offset-2 decoration-[#D4A359] hover:text-[#D4A359] transition-colors"
        data-testid="countdown-cta"
      >
        Claim offer
      </button>
    </div>
  );
}
